import watchGetEmailValidateSaga from './getEmailValidateSaga';

export default [
  watchGetEmailValidateSaga(),
];
